import React from "react";
import { useTitle } from "../../hooks/useTitle";
import SEO from "../../Components/SEO/SEO";
import "./Shop.css";
import Footer from "../../Components/Footer/Footer";
import Navbar from "../../Components/Navbar/Navbar";
import { ArrowRight } from "lucide-react";

const CATEGORIES = [
  { slug: "reup-vault",                label: "ReUp Vault",                emoji: "🔁" },
  { slug: "value-packs",               label: "Value Packs",               emoji: "📦" },
  { slug: "fresh-farm-produce",        label: "Fresh Farm Produce",        emoji: "🥦" },
  { slug: "grains-and-staples",        label: "Grains & Staples",          emoji: "🌾" },
  { slug: "meat-and-livestock",        label: "Meat & Livestock",          emoji: "🥩" },
  { slug: "dairy-and-eggs",            label: "Dairy & Eggs",              emoji: "🥚" },
  { slug: "beverages",                 label: "Beverages",                 emoji: "🥤" },
  { slug: "snacks-and-confectionery",  label: "Snacks & Confectionery",    emoji: "🍫" },
  { slug: "canned-and-packaged-foods", label: "Canned & Packaged Foods",   emoji: "🥫" },
  { slug: "frozen-foods",              label: "Frozen Foods",              emoji: "🧊" },
  { slug: "condiments-and-sauces",     label: "Condiments & Sauces",       emoji: "🍯" },
];

export default function Shop() {
  useTitle("Shop by Category - TrendBay");

  return (
    <div className="shop-page">
      <SEO
        title="Shop by Category"
        description="Explore all categories on TrendBay Mart — fresh farm produce, grains, dairy, beverages, snacks, frozen foods, and authentic pre-owned items. Fast delivery across Nigeria."
        path="/shop"
      />
      <Navbar />
      <div className="shop-wrap">
        <div className="shop-header">
          <h1 className="shop-title">Shop by Category</h1>
          <a href="/shop/all" className="shop-view-all">
            View All Products <ArrowRight size={16} />
          </a>
        </div>

        <div className="shop-grid">
          {CATEGORIES.map((cat) => (
            <a key={cat.slug} href={`/shop/${cat.slug}`} className="shop-card">
              <span className="shop-card__emoji">{cat.emoji}</span>
              <span className="shop-card__label">{cat.label}</span>
              <ArrowRight size={14} className="shop-card__arrow" />
            </a>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
